export default class Advisor {
  constructor(data = null) {
    const jsonData = !!data ? data : JSON.parse(document.getElementById('ADVISOR_JSON').textContent);
    for (const key in jsonData) {
      this[key] = jsonData[key];
    }
  }

  hasFeature(featureName) {
    return !!this.user?.feature_flags?.includes(`Feature: ${featureName}`);
  }
}
